<template>
  <v-app>
    <v-overlay :absolute="false" :value="wait" :opacity="0.75" z-index="999">
      <v-progress-linear :size="150" :width="10" color="#eeeeff" indeterminate></v-progress-linear>
    </v-overlay>

    <AppNavDrawer />
    <AppTopBar />

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
// import Chat from '@/components/chat/Chat.vue';
// import io from 'socket.io-client';

import AppTopBar from '@/layouts/app/AppTopBar.vue';
import AppNavDrawer from '@/layouts/app/AppNavDrawer.vue';

// UI Composable
import { useUi } from '@/module/ui';

import { useAuth } from '@/module/auth';

const { refreshAssertionContext } = useAuth();

export default defineComponent({
  name: 'AppLayout',
  components: {
    AppTopBar,
    AppNavDrawer
    // Chat
  },

  setup() {
    refreshAssertionContext();

    const { wait, waitToggle } = useUi();

    return { wait, waitToggle };
  }
});
</script>
